import { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react'
import { FiSmartphone, FiCheck, FiX, FiAlertCircle, FiTrash2, FiChevronRight, FiLink, FiPlus, FiBarChart2 } from 'react-icons/fi'
import ConfirmDialog from './ConfirmDialog'

// Ícone de IA customizado - SVG do ai_6.svg (estrela/brilho) com cor dinâmica (azul=ativo, cinza=inativo)
const IaIcon = ({ className, active = true }: { className?: string; active?: boolean }) => (
  <svg
    viewBox="0 0 1080 1080"
    fill={active ? "#3b82f6" : "#6b7280"}
    className={className}
  >
    <path d="M0 0 C17.32 10.35 22.3 38.27 28.19 56 C43.16 100.59 53.19 124.81 137.46 258.99 C234.51 344.23 368.73 396.8 426.75 425.19 C429.09 437.69 426.13 443.38 409 455.85 C361.52 475.48 297.31 499.23 255.76 519.13 C147.88 599.25 87.23 669.21 34.04 795.49 C14.94 849.69 10.85 859.25 -0.63 869 C-25.39 865.84 -41.29 832.75 -56.54 791.65 C-86.69 715.73 -151.25 619.5 -240.16 536.07 C-356.56 484.44 -426 459.63 -444.81 449.6 C-448.77 434.62 -432.64 415.05 -408.25 405.5 C-303.6 364.86 -219.25 313.5 -151.27 251.07 C-92.87 164.85 -48.99 59.56 -19.13 -0.25 C-5.99 -2.65 0 0 0 0 Z" transform="translate(477.25,178.5)"/>
    <path d="M0 0 C5.87 1.5 9.02 6.76 12.14 11.65 C40.68 81.19 73.94 130.75 118.94 167.75 C178.12 193.54 218.94 215.75 219.94 221.75 C210.47 229.25 175.66 245.02 162.76 250.61 C89.16 293.71 49.63 340.19 25.14 396.89 C2.94 437.75 -2.69 437.82 -8.06 437.75 C-17.06 408.49 -51.73 327.75 -137.06 259.75 C-212.01 231.28 -217.68 223.22 -217.19 214.69 C-203.03 204.09 -166.14 189.08 -92.06 147.75 C-24.64 43.58 -9.76 8.56 0 0 Z" transform="translate(852.06,9.25)"/>
  </svg>
)

// Ícone WhatsApp SVG customizado - exportado para uso externo
export const WhatsAppIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 32 32"
    fill="currentColor"
    className={className}
  >
    <path d="M26.576 5.363c-2.69-2.69-6.406-4.354-10.511-4.354-8.209 0-14.865 6.655-14.865 14.865 0 2.732 0.737 5.291 2.022 7.491l-0.038-0.070-2.109 7.702 7.879-2.067c2.051 1.139 4.498 1.809 7.102 1.809h0.006c8.209-0.003 14.862-6.659 14.862-14.868 0-4.103-1.662-7.817-4.349-10.507l0 0zM16.062 28.228h-0.005c-0 0-0.001 0-0.001 0-2.319 0-4.489-0.64-6.342-1.753l0.056 0.031-0.451-0.267-4.675 1.227 1.247-4.559-0.294-0.467c-1.185-1.862-1.889-4.131-1.889-6.565 0-6.822 5.531-12.353 12.353-12.353s12.353 5.531 12.353 12.353c0 6.822-5.53 12.353-12.353 12.353h-0zM22.838 18.977c-0.371-0.186-2.197-1.083-2.537-1.208-0.341-0.124-0.589-0.185-0.837 0.187-0.246 0.371-0.958 1.207-1.175 1.455-0.216 0.249-0.434 0.279-0.805 0.094-1.15-0.466-2.138-1.087-2.997-1.852l0.010 0.009c-0.799-0.74-1.484-1.587-2.037-2.521l-0.028-0.052c-0.216-0.371-0.023-0.572 0.162-0.757 0.167-0.166 0.372-0.434 0.557-0.65 0.146-0.179 0.271-0.384 0.366-0.604l0.006-0.017c0.043-0.087 0.068-0.188 0.068-0.296 0-0.131-0.037-0.253-0.101-0.357l0.002 0.003c-0.094-0.186-0.836-2.014-1.145-2.758-0.302-0.724-0.609-0.625-0.836-0.637-0.216-0.010-0.464-0.012-0.712-0.012-0.395 0.010-0.746 0.188-0.988 0.463l-0.001 0.002c-0.802 0.761-1.3 1.834-1.3 3.023 0 0.026 0 0.053 0.001 0.079l-0-0.004c0.131 1.467 0.681 2.784 1.527 3.857l-0.012-0.015c1.604 2.379 3.742 4.282 6.251 5.564l0.094 0.043c0.548 0.248 1.25 0.513 1.968 0.74l0.149 0.041c0.442 0.14 0.951 0.221 1.479 0.221 0.303 0 0.601-0.027 0.889-0.078l-0.031 0.004c1.069-0.223 1.956-0.868 2.497-1.749l0.009-0.017c0.165-0.366 0.261-0.793 0.261-1.242 0-0.185-0.016-0.366-0.047-0.542l0.003 0.019c-0.092-0.155-0.34-0.247-0.712-0.434z"/>
  </svg>
)

// Ícone Meta SVG customizado - exportado para uso externo (do arquivo public/meta-logo-facebook-svgrepo-com.svg)
export const MetaIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 32 32"
    fill="currentColor"
    className={className}
  >
    <path d="M5,19.5c0-4.6,2.3-9.4,5-9.4c1.5,0,2.7,0.9,4.6,3.6c-1.8,2.8-2.9,4.5-2.9,4.5c-2.4,3.8-3.2,4.6-4.5,4.6C5.9,22.9,5,21.7,5,19.5 M20.7,17.8L19,15c-0.4-0.7-0.9-1.4-1.3-2c1.5-2.3,2.7-3.5,4.2-3.5c3,0,5.4,4.5,5.4,10.1c0,2.1-0.7,3.3-2.1,3.3S23.3,22,20.7,17.8 M16.4,11c-2.2-2.9-4.1-4-6.3-4C5.5,7,2,13.1,2,19.5c0,4,1.9,6.5,5.1,6.5c2.3,0,3.9-1.1,6.9-6.3c0,0,1.2-2.2,2.1-3.7c0.3,0.5,0.6,1,0.9,1.6l1.4,2.4c2.7,4.6,4.2,6.1,6.9,6.1c3.1,0,4.8-2.6,4.8-6.7C30,12.6,26.4,7,22.1,7C19.8,7,18,8.8,16.4,11"/>
  </svg>
)
import { io, Socket } from 'socket.io-client'
import { useAuth } from '../contexts/AuthContext'

// Hook para verificar permissão de dispositivo
const useDevicePermissions = () => {
  const { user, hasDeviceAccess, getDevicePermission } = useAuth()
  return { user, hasDeviceAccess, getDevicePermission }
}

// ============================================
// INTERFACES
// ============================================

interface ConnectionInfo {
  ownerJid: string
  profileName: string
  profilePicUrl: string
  connectionStatus: string
}

interface Device {
  id: string
  name: string
  createdAt: string
  qrCode?: string
  pairingCode?: string
  connectionInfo?: ConnectionInfo
  aiAgentEnabled?: boolean
  agentName?: string
  agentEmoji?: string
  lastHealthCheck?: string
  unreadCount?: number
  apiType?: 'evolution' | 'meta'
  displayPhone?: string
  // Detalhes de não lidas com urgência
  unreadActive?: { count: number; hoursOld: number | null }
  unreadArchived?: { count: number; hoursOld: number | null }
}

// ============================================
// URGENCY COLORS - Cores baseadas em horas sem responder
// Verde: < 2 horas | Amarelo: 2-6 horas | Vermelho: > 6 horas
// ============================================
const URGENCY_THRESHOLDS = {
  GREEN_MAX_HOURS: 2,   // Até 2 horas = verde
  YELLOW_MAX_HOURS: 6   // 2-6 horas = amarelo, > 6 = vermelho
}

// Função para calcular cor de urgência baseada em horas
const getUrgencyColor = (hoursOld: number | null): 'green' | 'yellow' | 'red' => {
  if (hoursOld === null || hoursOld < URGENCY_THRESHOLDS.GREEN_MAX_HOURS) return 'green'
  if (hoursOld < URGENCY_THRESHOLDS.YELLOW_MAX_HOURS) return 'yellow'
  return 'red'
}

// Classes CSS para cada nível de urgência
const urgencyStyles = {
  green: {
    badge: 'bg-green-500 text-white',
    ring: 'ring-green-300',
    text: 'text-green-500'
  },
  yellow: {
    badge: 'bg-yellow-500 text-white',
    ring: 'ring-yellow-300',
    text: 'text-yellow-500'
  },
  red: {
    badge: 'bg-red-500 text-white',
    ring: 'ring-red-300',
    text: 'text-red-500'
  }
}

// Evolution API removida em 2026-05-14 — stack opera só com Meta API.
// Stub mantido pra qualquer caminho antigo da UI que ainda referencie:
// chamadas falham com erro claro em vez de hit numa Evolution decommissionada.
// Sem chaves hardcoded no bundle do cliente.
const evolutionFetch = async (_endpoint: string, _options: RequestInit = {}): Promise<Response> => {
  throw new Error('Evolution API foi removida em 2026-05-14. Use Meta API.')
}

const QR_TIMEOUT_SECONDS = 60
const POLLING_INTERVAL_MS = 3000 // Polling para QR code (otimizado)
const HEALTH_CHECK_INTERVAL_MS = 120000 // Health check a cada 2 minutos (otimizado)

// ============================================
// COMPONENT
// ============================================

interface DevicesPanelProps {
  onOpenInbox?: (deviceId: string, deviceName: string, aiEnabled: boolean, apiType?: 'evolution' | 'meta') => void
  onCloseInbox?: () => void
  onOpenAnalytics?: (deviceId: string, deviceName: string) => void
  activeInboxDeviceId?: string | null
  activeAnalyticsDeviceId?: string | null
  showNewDeviceForm?: boolean
  onNewDeviceFormChange?: (show: boolean) => void
}

// Interface para expor métodos do DevicesPanel via ref
export interface DevicesPanelRef {
  decrementUnreadCount: (deviceId: string, amount?: number) => void
  resetUnreadCount: (deviceId: string) => void
  refreshUnreadCounts: () => void
}

export const DevicesPanel = forwardRef<DevicesPanelRef, DevicesPanelProps>(function DevicesPanel({ onOpenInbox, onCloseInbox, onOpenAnalytics, activeInboxDeviceId, activeAnalyticsDeviceId, showNewDeviceForm, onNewDeviceFormChange }, ref) {
  const { authenticatedFetch } = useAuth()
  const { user, hasDeviceAccess } = useDevicePermissions()

  // State
  const [devices, setDevices] = useState<Device[]>([])

  // Expor métodos para controlar contador de não lidas via ref
  useImperativeHandle(ref, () => ({
    decrementUnreadCount: (deviceId: string, amount: number = 1) => {
      setDevices(prev => prev.map(device => {
        const count = Number(device.unreadCount) || 0
        if (device.id === deviceId && count > 0) {
          return { ...device, unreadCount: Math.max(0, count - amount) }
        }
        return device
      }))
    },
    resetUnreadCount: (deviceId: string) => {
      setDevices(prev => prev.map(device => {
        if (device.id === deviceId) {
          return { ...device, unreadCount: 0 }
        }
        return device
      }))
    },
    refreshUnreadCounts: () => {
      const connectedDevices = devices.filter(d => d.connectionInfo)
      if (connectedDevices.length > 0) {
        loadUnreadCounts(connectedDevices)
      }
    }
  }))
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  // New instance form state - controlled externally or internally
  const [internalShowForm, setInternalShowForm] = useState(false)
  const showNewInstanceForm = showNewDeviceForm ?? internalShowForm
  const setShowNewInstanceForm = onNewDeviceFormChange ?? setInternalShowForm
  const [newInstanceName, setNewInstanceName] = useState('')
  const [newInstancePhone, setNewInstancePhone] = useState('')
  const [isCreatingInstance, setIsCreatingInstance] = useState(false)

  // Choice screen state: 'choice' | 'new' | 'existing' | null
  const [deviceFormMode, setDeviceFormMode] = useState<'choice' | 'new' | 'existing' | null>(null)

  // Existing instance form state (inline)
  const [existingInstanceName, setExistingInstanceName] = useState('')
  const [existingInstanceApiKey, setExistingInstanceApiKey] = useState('')
  const [isSavingExistingInstance, setIsSavingExistingInstance] = useState(false)

  // QR Code state
  const [pendingQRCode, setPendingQRCode] = useState<string | null>(null)
  const [pendingPairingCode, setPendingPairingCode] = useState<string | null>(null)
  const [pendingInstanceName, setPendingInstanceName] = useState<string | null>(null)
  const [countdown, setCountdown] = useState(QR_TIMEOUT_SECONDS)
  const [connectionStatus, setConnectionStatus] = useState<'waiting' | 'connected' | 'expired'>('waiting')
  const [showQRModal, setShowQRModal] = useState(false)

  // Delete confirmation state
  const [deleteConfirmation, setDeleteConfirmation] = useState<{ isOpen: boolean; device: Device | null }>({
    isOpen: false,
    device: null
  })

  // Agent selection modal state
  const [agentSelectionModal, setAgentSelectionModal] = useState<{
    isOpen: boolean
    deviceId: string | null
    deviceName: string | null
  }>({
    isOpen: false,
    deviceId: null,
    deviceName: null
  })
  const [availableAgents, setAvailableAgents] = useState<Array<{ id: string; name: string; emoji: string }>>([])
  const [selectedAgentId, setSelectedAgentId] = useState<string | null>(null)
  const [isLoadingAgents, setIsLoadingAgents] = useState(false)

  // Refs for intervals
  const countdownRef = useRef<NodeJS.Timeout | null>(null)
  const pollingRef = useRef<NodeJS.Timeout | null>(null)
  const healthCheckRef = useRef<NodeJS.Timeout | null>(null)
  const socketRef = useRef<Socket | null>(null)

  // ============================================
  // EFFECTS
  // ============================================

  // Load devices on mount
  useEffect(() => {
    loadDevices()
    return () => {
      cleanup()
    }
  }, [])

  // Set deviceFormMode to 'choice' when showNewInstanceForm becomes true
  useEffect(() => {
    if (showNewInstanceForm && !pendingQRCode) {
      setDeviceFormMode('choice')
    } else if (!showNewInstanceForm) {
      setDeviceFormMode(null)
    }
  }, [showNewInstanceForm, pendingQRCode])

  // WebSocket para receber notificações de novas mensagens
  useEffect(() => {
    const connectedDevices = devices.filter(d => d.connectionInfo)
    if (connectedDevices.length === 0) return

    // Conectar ao WebSocket se ainda não conectado
    if (!socketRef.current) {
      const token = localStorage.getItem('auth-token')
      const socket = io(`${window.location.origin}/whatsapp`, {
        path: '/socket.io',
        transports: ['websocket', 'polling'],
        auth: { token },
        reconnection: true,
        reconnectionAttempts: 5
      })

      socket.on('connect', () => {
        console.log('[DevicesPanel] WebSocket conectado para notificações')
        // Entrar na sala de cada dispositivo conectado
        connectedDevices.forEach(device => {
          socket.emit('join_device', device.id)
        })
      })

      // Escutar novas mensagens recebidas (não fromMe)
      socket.on('new_message', (data: { deviceId: string, conversationId: string }) => {
        console.log('[DevicesPanel] Nova mensagem recebida:', data)
        // Incrementar contador de não lidas do dispositivo
        setDevices(prev => prev.map(device => {
          if (device.id === data.deviceId) {
            return { ...device, unreadCount: (Number(device.unreadCount) || 0) + 1 }
          }
          return device
        }))
      })

      socketRef.current = socket
    } else {
      // Se já conectado, entrar nas salas dos novos dispositivos
      connectedDevices.forEach(device => {
        socketRef.current?.emit('join_device', device.id)
      })
    }

    return () => {
      // Não desconectar no cleanup para manter a conexão
    }
  }, [devices])

  // Start health check when we have connected devices
  useEffect(() => {
    const hasConnectedDevices = devices.some(d => d.connectionInfo)

    if (hasConnectedDevices && !healthCheckRef.current) {
      startHealthCheck()
    } else if (!hasConnectedDevices && healthCheckRef.current) {
      clearInterval(healthCheckRef.current)
      healthCheckRef.current = null
    }
  }, [devices])

  // REMOVIDO: Não zerar contador ao abrir inbox
  // O badge só deve ser decrementado quando o usuário clicar em cada conversa
  // A atualização do badge é feita via prop onUnreadCountChange

  // ============================================
  // CLEANUP
  // ============================================

  const cleanup = useCallback(() => {
    if (countdownRef.current) clearInterval(countdownRef.current)
    if (pollingRef.current) clearInterval(pollingRef.current)
    if (healthCheckRef.current) clearInterval(healthCheckRef.current)
    if (socketRef.current) {
      socketRef.current.disconnect()
      socketRef.current = null
    }
  }, [])

  const resetQRState = useCallback(() => {
    if (countdownRef.current) clearInterval(countdownRef.current)
    if (pollingRef.current) clearInterval(pollingRef.current)

    setPendingQRCode(null)
    setPendingPairingCode(null)
    setPendingInstanceName(null)
    setCountdown(QR_TIMEOUT_SECONDS)
    setConnectionStatus('waiting')
    setShowNewInstanceForm(false)
    setNewInstanceName('')
    setNewInstancePhone('')
    setIsCreatingInstance(false)
    setShowQRModal(false)
  }, [])

  // Função para deletar instância pendente e resetar para tentar novamente
  const deleteInstanceAndRetry = useCallback(async () => {
    if (pendingInstanceName) {
      console.log(`[Evolution] Deletando instância "${pendingInstanceName}" para tentar novamente...`)
      try {
        await evolutionFetch(`/instance/delete/${pendingInstanceName}`, {
          method: 'DELETE'
        })
        console.log(`[Evolution] Instância "${pendingInstanceName}" deletada com sucesso`)
      } catch (error) {
        console.error(`[Evolution] Erro ao deletar instância:`, error)
      }
    }

    // Reset state mas mantém o formulário aberto para tentar novamente
    if (countdownRef.current) clearInterval(countdownRef.current)
    if (pollingRef.current) clearInterval(pollingRef.current)

    setPendingQRCode(null)
    setPendingPairingCode(null)
    setPendingInstanceName(null)
    setCountdown(QR_TIMEOUT_SECONDS)
    setConnectionStatus('waiting')
    setIsCreatingInstance(false)
    setShowQRModal(false)
    // NÃO reseta newInstanceName e newInstancePhone para o usuário poder tentar com o mesmo nome
  }, [pendingInstanceName])

  // ============================================
  // API FUNCTIONS
  // ============================================

  const loadDevices = async () => {
    setIsLoading(true)
    try {
      // Carregar dispositivos Evolution (todos os do banco)
      const response = await authenticatedFetch('/api/whatsapp-devices')
      if (!response.ok) throw new Error('Erro ao carregar dispositivos')

      const dbDevices = await response.json()

      const convertedDevices: Device[] = dbDevices.map((d: any) => ({
        id: d.id,
        name: d.name,
        createdAt: d.created_at,
        aiAgentEnabled: d.ai_agent_enabled === 1 || d.ai_agent_enabled === true,
        agentName: d.agent_name,
        agentEmoji: d.agent_emoji,
        connectionInfo: d.connection_status === 'open' && d.owner_jid ? {
          ownerJid: d.owner_jid,
          profileName: d.profile_name,
          profilePicUrl: d.profile_pic_url,
          connectionStatus: d.connection_status
        } : d.api_type === 'meta' && d.connection_status === 'connected' ? {
          ownerJid: d.display_phone || d.phone_number_id || '',
          profileName: d.name,
          profilePicUrl: '',
          connectionStatus: 'open'
        } : undefined,
        unreadCount: 0,
        apiType: d.api_type || 'evolution',
        displayPhone: d.display_phone
      }))

      // Filtrar dispositivos baseado nas permissões do usuário
      // Admin vê todos, usuário normal só vê os que tem permissão
      const filteredDevices = user?.isAdmin
        ? convertedDevices
        : convertedDevices.filter(d => hasDeviceAccess(d.id))

      setDevices(filteredDevices)

      // Buscar contagem de não lidas para cada dispositivo
      loadUnreadCounts(filteredDevices)

      // Verificar TODOS os dispositivos Evolution na API (não dispositivos Meta - eles são sempre "conectados")
      const evolutionDevices = filteredDevices.filter(d => d.apiType !== 'meta')
      if (evolutionDevices.length > 0) {
        verifyDevicesConnection(evolutionDevices)
      }
    } catch (err) {
      console.error('Erro ao carregar dispositivos:', err)
      setError('Erro ao carregar dispositivos')
    } finally {
      setIsLoading(false)
    }
  }

  // Buscar contagem de mensagens não lidas (com detalhes de urgência)
  const loadUnreadCounts = async (devicesList: Device[]) => {
    try {
      const counts = await Promise.all(
        devicesList.map(async (device) => {
          try {
            const response = await authenticatedFetch(`/api/whatsapp-unread/${device.id}`)
            if (response.ok) {
              const data = await response.json()
              return {
                deviceId: device.id,
                count: Number(data.unreadCount) || 0,
                active: data.active || { count: 0, hoursOld: null },
                archived: data.archived || { count: 0, hoursOld: null }
              }
            }
            return { deviceId: device.id, count: 0, active: { count: 0, hoursOld: null }, archived: { count: 0, hoursOld: null } }
          } catch {
            return { deviceId: device.id, count: 0, active: { count: 0, hoursOld: null }, archived: { count: 0, hoursOld: null } }
          }
        })
      )

      setDevices(prev => prev.map(device => {
        const found = counts.find(c => c.deviceId === device.id)
        return found ? {
          ...device,
          unreadCount: found.count,
          unreadActive: found.active,
          unreadArchived: found.archived
        } : device
      }))
    } catch (err) {
      console.error('Erro ao carregar contagem de não lidas:', err)
    }
  }

  // Verificar conexão real dos dispositivos na Evolution API
  const verifyDevicesConnection = async (devicesToVerify: Device[]) => {
    for (const device of devicesToVerify) {
      try {
        // Usar Evolution API diretamente: /instance/connectionState/{instanceName}
        const response = await evolutionFetch(`/instance/connectionState/${device.name}`)

        if (!response.ok) {
          await updateDeviceAsDisconnected(device.id, device.name)
          continue
        }

        const data = await response.json()

        // Evolution API retorna: { instance: { instanceName, state } }
        const state = data?.instance?.state || data?.state

        if (state !== 'open') {
          await updateDeviceAsDisconnected(device.id, device.name)
        } else {
          // Dispositivo está conectado - buscar info adicional via fetchInstances
          const infoResponse = await evolutionFetch(`/instance/fetchInstances?instanceName=${device.name}`)
          let instanceData = { name: device.name, connectionStatus: 'open' }

          if (infoResponse.ok) {
            const infoResult = await infoResponse.json()
            // Pode retornar array ou objeto
            if (Array.isArray(infoResult)) {
              instanceData = infoResult.find((i: any) => i.name === device.name) || instanceData
            } else if (infoResult.instance) {
              instanceData = infoResult.instance
            }
          }

          await updateDeviceAsConnected(device.id, device.name, instanceData)
        }
      } catch (error) {
        console.error(`Erro ao verificar ${device.name}:`, error)
        await updateDeviceAsDisconnected(device.id, device.name)
      }
    }
  }

  // Atualizar dispositivo como conectado
  const updateDeviceAsConnected = async (deviceId: string, deviceName: string, instanceData: any) => {
    try {
      const connectionInfo = {
        ownerJid: instanceData.ownerJid || '',
        profileName: instanceData.profileName || deviceName,
        profilePicUrl: instanceData.profilePicUrl || '',
        connectionStatus: 'open'
      }

      // Atualizar no banco
      await authenticatedFetch('/api/whatsapp-devices', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: deviceId,
          name: deviceName,
          connection_status: 'open',
          owner_jid: connectionInfo.ownerJid,
          profile_name: connectionInfo.profileName,
          profile_pic_url: connectionInfo.profilePicUrl
        })
      })

      // Atualizar estado local
      setDevices(prev => prev.map(d =>
        d.id === deviceId ? { ...d, connectionInfo } : d
      ))

      console.log(`Dispositivo "${deviceName}" confirmado como conectado`)
    } catch (error) {
      console.error('Erro ao atualizar dispositivo como conectado:', error)
    }
  }

  // Atualizar dispositivo como desconectado no banco e estado
  const updateDeviceAsDisconnected = async (deviceId: string, deviceName: string) => {
    try {
      // Usar o endpoint correto (POST sem ID no path)
      await authenticatedFetch('/api/whatsapp-devices', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: deviceId,
          name: deviceName,
          connection_status: 'closed',
          owner_jid: null,
          profile_name: null,
          profile_pic_url: null
        })
      })

      // Manter o dispositivo na lista mas sem connectionInfo (aparecerá como desconectado)
      setDevices(prev => prev.map(d =>
        d.id === deviceId ? { ...d, connectionInfo: undefined } : d
      ))

      console.log(`Dispositivo "${deviceName}" marcado como desconectado`)
    } catch (error) {
      console.error('Erro ao atualizar dispositivo:', error)
      // Mesmo com erro, atualizar o estado local para mostrar como desconectado
      setDevices(prev => prev.map(d =>
        d.id === deviceId ? { ...d, connectionInfo: undefined } : d
      ))
    }
  }

  const saveDeviceToDb = async (device: Partial<Device>) => {
    try {
      const response = await authenticatedFetch('/api/whatsapp-devices', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: device.id,
          name: device.name,
          owner_jid: device.connectionInfo?.ownerJid,
          profile_name: device.connectionInfo?.profileName,
          profile_pic_url: device.connectionInfo?.profilePicUrl,
          connection_status: device.connectionInfo?.connectionStatus
        })
      })

      if (!response.ok) throw new Error('Erro ao salvar dispositivo')
      return await response.json()
    } catch (err) {
      console.error('Erro ao salvar no banco:', err)
    }
  }

  // ============================================
  // SAVE EXISTING INSTANCE (inline form)
  // ============================================

  const handleSaveExistingInstanceInline = async () => {
    if (!existingInstanceName.trim() || !existingInstanceApiKey.trim()) {
      setError('Nome e API Key são obrigatórios')
      return
    }

    setIsSavingExistingInstance(true)
    setError(null)

    try {
      // Salvar instância existente no banco de dados
      const response = await authenticatedFetch('/api/evolution-instances', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: existingInstanceName.trim(),
          apiKey: existingInstanceApiKey.trim()
        })
      })

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.error || 'Erro ao salvar instância')
      }

      setSuccess(`Instância "${existingInstanceName}" adicionada com sucesso!`)

      // Reset form
      setExistingInstanceName('')
      setExistingInstanceApiKey('')
      setDeviceFormMode(null)
      setShowNewInstanceForm(false)

      // Recarregar lista de dispositivos
      loadDevices()
    } catch (err: any) {
      setError(err.message || 'Erro ao salvar instância')
    } finally {
      setIsSavingExistingInstance(false)
    }
  }

  // ============================================
  // CREATE INSTANCE
  // ============================================

  const createInstance = async () => {
    if (!newInstanceName.trim()) {
      setError('Digite o nome do cliente')
      return
    }

    setIsCreatingInstance(true)

    // Generate instance name from customer name
    const instanceName = newInstanceName
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')

    try {
      // Payload para Evolution API - criar instância com QR Code
      const payload = {
        instanceName: instanceName,
        token: instanceName, // Token igual ao nome
        qrcode: true,
        integration: 'WHATSAPP-BAILEYS',
        rejectCall: false,
        msgCall: '',
        groupsIgnore: true,
        alwaysOnline: false,
        readMessages: false,
        readStatus: false,
        syncFullHistory: true
      }

      // Adicionar número se fornecido
      if (newInstancePhone.trim()) {
        Object.assign(payload, { number: newInstancePhone.replace(/\D/g, '') })
      }

      console.log('[Evolution] Criando instância:', instanceName)

      // 1. Criar instância na Evolution API
      const createResponse = await evolutionFetch('/instance/create', {
        method: 'POST',
        body: JSON.stringify(payload)
      })

      if (!createResponse.ok) {
        const errorData = await createResponse.json().catch(() => ({}))
        throw new Error(errorData.message || `HTTP ${createResponse.status}`)
      }

      const createResult = await createResponse.json()
      console.log('[Evolution] Instância criada:', createResult)

      // Extrair QR Code da resposta de criação (pode vir junto)
      let qrCodeBase64 = null
      let pairingCode = null

      // A Evolution API pode retornar o QR na criação ou precisar de chamada separada
      if (createResult.qrcode?.base64) {
        qrCodeBase64 = createResult.qrcode.base64
      } else if (createResult.base64) {
        qrCodeBase64 = createResult.base64
      } else if (createResult.code) {
        qrCodeBase64 = createResult.code
      }

      if (createResult.qrcode?.pairingCode) {
        pairingCode = createResult.qrcode.pairingCode
      } else if (createResult.pairingCode) {
        pairingCode = createResult.pairingCode
      }

      // 2. Se não veio QR na criação, buscar via /instance/connect
      if (!qrCodeBase64) {
        console.log('[Evolution] Buscando QR Code via connect...')

        // Pequeno delay para a instância inicializar
        await new Promise(resolve => setTimeout(resolve, 1000))

        const qrResponse = await evolutionFetch(`/instance/connect/${instanceName}`)

        if (qrResponse.ok) {
          const qrResult = await qrResponse.json()
          console.log('[Evolution] Resposta do QR:', qrResult)

          if (qrResult.base64) {
            qrCodeBase64 = qrResult.base64
          } else if (qrResult.code) {
            qrCodeBase64 = qrResult.code
          } else if (qrResult.qrcode) {
            qrCodeBase64 = typeof qrResult.qrcode === 'string' ? qrResult.qrcode : qrResult.qrcode.base64
          }

          if (qrResult.pairingCode) {
            pairingCode = qrResult.pairingCode
          }
        }
      }

      if (qrCodeBase64) {
        // Format QR code as data URL if needed
        const qrCodeUrl = qrCodeBase64.startsWith('data:image')
          ? qrCodeBase64
          : `data:image/png;base64,${qrCodeBase64}`

        setPendingQRCode(qrCodeUrl)
        setPendingPairingCode(pairingCode)
        setPendingInstanceName(instanceName)
        setConnectionStatus('waiting')
        setCountdown(QR_TIMEOUT_SECONDS)

        // Start countdown and polling
        startCountdown()
        startConnectionPolling(instanceName)
      } else {
        // Se ainda não tem QR, pode ser que a instância já esteja conectada ou erro
        console.warn('[Evolution] QR Code não retornado, verificando status...')
        setSuccess('Instância criada! Verifique a lista.')
        resetQRState()
        loadDevices()
      }

    } catch (error: any) {
      console.error('Erro ao criar instância:', error)
      setError(`Erro ao criar instância: ${error.message}`)
      setIsCreatingInstance(false)
    }
  }

  // ============================================
  // COUNTDOWN & POLLING
  // ============================================

  const startCountdown = () => {
    if (countdownRef.current) clearInterval(countdownRef.current)

    setCountdown(QR_TIMEOUT_SECONDS)

    countdownRef.current = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          handleQRExpired()
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }

  const handleQRExpired = async () => {
    if (countdownRef.current) clearInterval(countdownRef.current)
    if (pollingRef.current) clearInterval(pollingRef.current)

    setConnectionStatus('expired')
    setShowQRModal(false)

    // Deletar a instância automaticamente da Evolution API para permitir recriar com mesmo nome
    if (pendingInstanceName) {
      console.log(`[Evolution] QR expirado - deletando instância "${pendingInstanceName}"...`)
      try {
        await evolutionFetch(`/instance/delete/${pendingInstanceName}`, {
          method: 'DELETE'
        })
        console.log(`[Evolution] Instância "${pendingInstanceName}" deletada com sucesso`)
      } catch (error) {
        console.error(`[Evolution] Erro ao deletar instância:`, error)
      }
    }
  }

  const startConnectionPolling = (instanceName: string) => {
    if (pollingRef.current) clearInterval(pollingRef.current)

    pollingRef.current = setInterval(async () => {
      try {
        // Usar Evolution API: /instance/connectionState/{instanceName}
        const response = await evolutionFetch(`/instance/connectionState/${instanceName}`)
        if (!response.ok) return

        const data = await response.json()

        // Evolution API retorna: { instance: { instanceName, state } }
        const state = data?.instance?.state || data?.state
        let isConnected = state === 'open'
        let instanceData = null

        if (isConnected) {
          // Buscar informações adicionais da instância
          const infoResponse = await evolutionFetch(`/instance/fetchInstances?instanceName=${instanceName}`)
          if (infoResponse.ok) {
            const infoResult = await infoResponse.json()
            if (Array.isArray(infoResult)) {
              instanceData = infoResult.find((i: any) => i.name === instanceName)
            } else if (infoResult.instance) {
              instanceData = infoResult.instance
            } else {
              instanceData = infoResult
            }
          }

          if (!instanceData) {
            instanceData = { name: instanceName, connectionStatus: 'open' }
          }
        }

        if (isConnected && instanceData) {
          handleConnectionSuccess(instanceName, instanceData)
        }
      } catch (error) {
        console.log('Erro no polling:', error)
      }
    }, POLLING_INTERVAL_MS)
  }

  const handleConnectionSuccess = async (instanceName: string, instanceData: any) => {
    // Stop timers
    if (countdownRef.current) clearInterval(countdownRef.current)
    if (pollingRef.current) clearInterval(pollingRef.current)

    setConnectionStatus('connected')
    setShowQRModal(false)

    // Configurar webhook e settings automaticamente na instância recém-conectada
    await configureInstanceSettings(instanceName)

    // Create device object
    const newDevice: Device = {
      id: `device_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`,
      name: instanceName,
      createdAt: new Date().toISOString(),
      connectionInfo: {
        ownerJid: instanceData.ownerJid || '',
        profileName: instanceData.profileName || instanceName,
        profilePicUrl: instanceData.profilePicUrl || '',
        connectionStatus: 'open'
      },
      aiAgentEnabled: false
    }

    // Save to database
    await saveDeviceToDb(newDevice)

    // Update local state
    setDevices(prev => [...prev, newDevice])

    setSuccess(`${instanceData.profileName || instanceName} conectado com sucesso!`)

    // Close panel after 2 seconds
    setTimeout(() => {
      resetQRState()
    }, 2000)
  }

  // Configurar webhook e settings da instância automaticamente
  const configureInstanceSettings = async (instanceName: string) => {
    const webhookUrl = `${window.location.origin}/api/webhook/evolution`

    try {
      console.log(`[Evolution] Configurando webhook para "${instanceName}"...`)

      // 1. Configurar Webhook - estrutura aninhada { webhook: { ... } }
      const webhookResponse = await evolutionFetch(`/webhook/set/${instanceName}`, {
        method: 'POST',
        body: JSON.stringify({
          webhook: {
            url: webhookUrl,
            enabled: true,
            webhookByEvents: false,
            webhookBase64: true,
            events: [
              'MESSAGES_UPSERT',
              'CONNECTION_UPDATE',
              'MESSAGES_UPDATE',
              'SEND_MESSAGE'
            ]
          }
        })
      })

      if (webhookResponse.ok) {
        const webhookResult = await webhookResponse.json()
        console.log(`[Evolution] Webhook configurado com sucesso:`, webhookResult)
      } else {
        const errorText = await webhookResponse.text()
        console.error(`[Evolution] Erro ao configurar webhook:`, errorText)
      }

      // 2. Configurar Settings da instância - estrutura aninhada { settings: { ... } }
      const settingsResponse = await evolutionFetch(`/settings/set/${instanceName}`, {
        method: 'POST',
        body: JSON.stringify({
          settings: {
            rejectCall: false,
            groupsIgnore: true,
            alwaysOnline: false,
            readMessages: false,
            readStatus: false,
            syncFullHistory: false
          }
        })
      })

      if (settingsResponse.ok) {
        console.log(`[Evolution] Settings configurados para "${instanceName}"`)
      } else {
        const errorText = await settingsResponse.text()
        console.error(`[Evolution] Erro ao configurar settings:`, errorText)
      }

    } catch (error) {
      console.error(`[Evolution] Erro ao configurar instância:`, error)
      // Não bloqueia o fluxo se falhar a configuração
    }
  }

  // ============================================
  // HEALTH CHECK
  // ============================================

  const startHealthCheck = () => {
    if (healthCheckRef.current) clearInterval(healthCheckRef.current)

    const checkHealth = async () => {
      // Filtrar apenas dispositivos Evolution conectados (Meta não precisa de health check)
      const connectedEvolutionDevices = devices.filter(d => d.connectionInfo && d.apiType !== 'meta')

      for (const device of connectedEvolutionDevices) {
        try {
          // Usar Evolution API: /instance/connectionState/{instanceName}
          const response = await evolutionFetch(`/instance/connectionState/${device.name}`)
          if (!response.ok) {
            await markDeviceAsDisconnected(device.id, device.name, 'Falha na comunicação com Evolution API')
            continue
          }

          const data = await response.json()

          // Evolution API retorna: { instance: { instanceName, state } }
          const state = data?.instance?.state || data?.state

          if (state !== 'open') {
            await markDeviceAsDisconnected(device.id, device.name, 'Dispositivo desconectado')
          } else {
            // Update last health check
            setDevices(prev => prev.map(d =>
              d.id === device.id ? { ...d, lastHealthCheck: new Date().toISOString() } : d
            ))
          }
        } catch (error) {
          console.error(`Health check error for ${device.name}:`, error)
          // Em caso de erro de rede/timeout, marcar como desconectado
          await markDeviceAsDisconnected(device.id, device.name, 'Erro de conexão')
        }
      }

      // Re-sincronizar contagem de não lidas do servidor (corrige drift entre badge e DB)
      const connectedDevices = devices.filter(d => d.connectionInfo)
      if (connectedDevices.length > 0) {
        loadUnreadCounts(connectedDevices)
      }
    }

    checkHealth()
    healthCheckRef.current = setInterval(checkHealth, HEALTH_CHECK_INTERVAL_MS)
  }

  // Marcar dispositivo como desconectado (atualizar banco sem deletar)
  const markDeviceAsDisconnected = async (deviceId: string, deviceName: string, reason: string) => {
    try {
      // Atualizar no banco para connection_status = 'closed' (endpoint correto)
      await authenticatedFetch('/api/whatsapp-devices', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: deviceId,
          name: deviceName,
          connection_status: 'closed',
          owner_jid: null,
          profile_name: null,
          profile_pic_url: null
        })
      })

      // Manter o dispositivo na lista mas sem connectionInfo (aparecerá como desconectado)
      setDevices(prev => prev.map(d =>
        d.id === deviceId ? { ...d, connectionInfo: undefined } : d
      ))

      const timestamp = new Date().toLocaleString('pt-BR')
      console.log(`[${timestamp}] Dispositivo "${deviceName}" marcado como desconectado. Motivo: ${reason}`)
    } catch (error) {
      console.error('Erro ao marcar dispositivo como desconectado:', error)
      // Mesmo com erro, atualizar o estado local
      setDevices(prev => prev.map(d =>
        d.id === deviceId ? { ...d, connectionInfo: undefined } : d
      ))
    }
  }

  // ============================================
  // DEVICE ACTIONS
  // ============================================

  // Abrir modal de confirmação de exclusão
  const confirmDeleteDevice = (device: Device) => {
    setDeleteConfirmation({ isOpen: true, device })
  }

  // Cancelar exclusão
  const cancelDeleteDevice = () => {
    setDeleteConfirmation({ isOpen: false, device: null })
  }

  // Executar exclusão após confirmação
  const executeDeleteDevice = async () => {
    const device = deleteConfirmation.device
    if (!device) return

    // Fechar modal imediatamente
    setDeleteConfirmation({ isOpen: false, device: null })

    try {
      // Para dispositivos Evolution, tentar deletar da API primeiro
      if (device.apiType === 'evolution') {
        try {
          const deleteResponse = await evolutionFetch(`/instance/delete/${device.name}`, {
            method: 'DELETE'
          })

          if (!deleteResponse.ok) {
            const errorData = await deleteResponse.json().catch(() => ({}))
            console.warn(`[Delete] Instância não encontrada na Evolution (${errorData.message}), continuando com delete do banco...`)
          }
        } catch (evolutionError) {
          console.warn('[Delete] Erro ao deletar da Evolution API, continuando com delete do banco:', evolutionError)
        }
      }

      // Delete from database (sempre executar, mesmo se Evolution falhar)
      const dbResponse = await authenticatedFetch(`/api/whatsapp-devices/${device.id}`, { method: 'DELETE' })

      if (!dbResponse.ok) {
        throw new Error('Erro ao remover dispositivo do banco de dados')
      }

      setDevices(prev => prev.filter(d => d.id !== device.id))
      setSuccess(`Instância "${device.name}" removida com sucesso`)
      setTimeout(() => setSuccess(null), 3000)
    } catch (error) {
      console.error('Erro ao deletar dispositivo:', error)
      setError(error instanceof Error ? error.message : 'Erro ao remover dispositivo')
      setTimeout(() => setError(null), 5000)
    }
  }

  // Carregar agentes disponíveis
  const loadAvailableAgents = async () => {
    setIsLoadingAgents(true)
    try {
      const response = await authenticatedFetch('/api/agents')
      if (response.ok) {
        const data = await response.json()
        if (data.success && Array.isArray(data.data)) {
          setAvailableAgents(data.data.map((agent: any) => ({
            id: agent.id,
            name: agent.name,
            emoji: agent.emoji
          })))
        }
      }
    } catch (error) {
      console.error('Erro ao carregar agentes:', error)
    } finally {
      setIsLoadingAgents(false)
    }
  }

  // Abrir modal de seleção de agente
  const openAgentSelectionModal = async (deviceId: string, deviceName: string, currentState: boolean) => {
    // Se está ativado, desativar diretamente sem modal
    if (currentState) {
      await toggleAiAgent(deviceId, deviceName, true, null)
      return
    }

    // Se está desativado, abrir modal para escolher agente
    setAgentSelectionModal({
      isOpen: true,
      deviceId,
      deviceName
    })
    setSelectedAgentId(null)
    await loadAvailableAgents()
  }

  // Confirmar ativação com agente selecionado
  const confirmAgentSelection = async () => {
    if (!agentSelectionModal.deviceId || !selectedAgentId) return

    await toggleAiAgent(
      agentSelectionModal.deviceId,
      agentSelectionModal.deviceName || '',
      false,
      selectedAgentId
    )

    // Fechar modal
    setAgentSelectionModal({
      isOpen: false,
      deviceId: null,
      deviceName: null
    })
    setSelectedAgentId(null)
  }

  // Cancelar seleção de agente
  const cancelAgentSelection = () => {
    setAgentSelectionModal({
      isOpen: false,
      deviceId: null,
      deviceName: null
    })
    setSelectedAgentId(null)
  }

  const toggleAiAgent = async (deviceId: string, deviceName: string, currentState: boolean, agentId: string | null) => {
    const newState = !currentState

    try {
      setDevices(prev => prev.map(d =>
        d.id === deviceId ? { ...d, aiAgentEnabled: newState } : d
      ))

      // Usar novo endpoint que reseta todas as conversas (Sistema Hierárquico)
      const response = await authenticatedFetch(`/api/whatsapp-devices/${deviceId}/ai`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          enabled: newState,
          agentId: agentId // Incluir ID do agente selecionado
        })
      })

      if (response.ok) {
        const result = await response.json()
        console.log(`[Evolution] Agente IA ${newState ? 'ativado' : 'desativado'} para ${deviceName}`)
        if (result.conversationsReset > 0) {
          console.log(`[Evolution] ${result.conversationsReset} conversas resetadas para status padrão`)
        }
      } else {
        throw new Error('Erro ao alternar agente')
      }
    } catch (error) {
      console.error('Erro ao alternar agente:', error)
      setDevices(prev => prev.map(d =>
        d.id === deviceId ? { ...d, aiAgentEnabled: currentState } : d
      ))
    }
  }

  // ============================================
  // HELPERS
  // ============================================

  const getInitials = (name: string) => {
    if (!name) return '?'
    const parts = name.split(/[\s-]+/)
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase()
    }
    return name.substring(0, 2).toUpperCase()
  }

  const formatPhone = (phone: string) => {
    if (!phone) return ''
    const cleaned = phone.replace(/@s\.whatsapp\.net$/, '').replace(/\D/g, '')
    if (cleaned.length === 13 && cleaned.startsWith('55')) {
      return `+${cleaned.slice(0,2)} (${cleaned.slice(2,4)}) ${cleaned.slice(4,9)}-${cleaned.slice(9)}`
    }
    return phone.split('@')[0]
  }

  // ============================================
  // RENDER
  // ============================================

  return (
    <div className="space-y-6">
      {/* Messages */}
      {error && (
        <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-3 flex items-start gap-2">
          <FiAlertCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-red-400 flex-1">{error}</p>
          <button onClick={() => setError(null)} className="text-red-400 hover:text-red-300">
            <FiX className="w-4 h-4" />
          </button>
        </div>
      )}

      {success && (
        <div className="bg-green-500/10 border border-green-500/20 rounded-lg p-3 flex items-start gap-2">
          <FiCheck className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-green-400 flex-1">{success}</p>
          <button onClick={() => setSuccess(null)} className="text-green-400 hover:text-green-300">
            <FiX className="w-4 h-4" />
          </button>
        </div>
      )}

      {/* Choice Screen - Select between new instance or existing */}
      {showNewInstanceForm && !pendingQRCode && deviceFormMode === 'choice' && (
        <div className="px-4 py-3">
          <div className="flex items-center gap-2 mb-3">
            <button
              onClick={() => {
                setDeviceFormMode(null)
                setShowNewInstanceForm(false)
              }}
              className="p-1 text-muted-foreground hover:text-foreground transition-colors"
            >
              <FiX className="w-4 h-4" />
            </button>
            <span className="text-sm font-medium">Adicionar Dispositivo</span>
          </div>
          <div className="grid grid-cols-2 gap-3">
            {/* Nova instância - Gerar QR */}
            <button
              onClick={() => setDeviceFormMode('new')}
              className="flex items-center gap-3 p-3 rounded-lg border border-border hover:border-green-500/50 hover:bg-green-500/5 transition-all"
            >
              <div className="w-10 h-10 rounded-lg bg-green-600 text-white flex items-center justify-center flex-shrink-0">
                <FiPlus className="w-5 h-5" />
              </div>
              <div className="text-left flex-1 min-w-0">
                <p className="font-medium text-sm">Nova Instância</p>
                <p className="text-[10px] text-muted-foreground">Escanear QR Code</p>
              </div>
              <FiChevronRight className="w-4 h-4 text-muted-foreground flex-shrink-0" />
            </button>

            {/* Instância existente - API Key */}
            <button
              onClick={() => setDeviceFormMode('existing')}
              className="flex items-center gap-3 p-3 rounded-lg border border-border hover:border-blue-500/50 hover:bg-blue-500/5 transition-all"
            >
              <div className="w-10 h-10 rounded-lg bg-blue-600 text-white flex items-center justify-center flex-shrink-0">
                <FiLink className="w-5 h-5" />
              </div>
              <div className="text-left flex-1 min-w-0">
                <p className="font-medium text-sm">Inserir Existente</p>
                <p className="text-[10px] text-muted-foreground">Nome + API Key</p>
              </div>
              <FiChevronRight className="w-4 h-4 text-muted-foreground flex-shrink-0" />
            </button>
          </div>
        </div>
      )}

      {/* New Instance Form + QR Code - Unified Inline Layout */}
      {showNewInstanceForm && deviceFormMode === 'new' && (
        <div className="px-4 py-4">
          <div className="flex items-stretch gap-5">
            {/* Botão Voltar */}
            <button
              onClick={() => {
                setDeviceFormMode('choice')
                resetQRState()
              }}
              className="p-2 text-muted-foreground hover:text-foreground hover:bg-muted/50 rounded-lg transition-colors flex-shrink-0 self-start"
              title="Voltar"
            >
              <FiX className="w-5 h-5" />
            </button>

            {/* Coluna 1: Campos */}
            <div className="flex flex-col gap-3 w-[200px] flex-shrink-0">
              <div>
                <label className="text-xs text-muted-foreground mb-1.5 block">Nome do cliente</label>
                <input
                  type="text"
                  value={newInstanceName}
                  onChange={(e) => setNewInstanceName(e.target.value)}
                  placeholder="Ex: João Silva"
                  className="w-full px-4 py-2.5 bg-background border border-border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary/50 transition-all"
                  disabled={isCreatingInstance || !!pendingQRCode}
                />
              </div>
              <div>
                <label className="text-xs text-muted-foreground mb-1.5 block">Telefone (opcional)</label>
                <input
                  type="tel"
                  value={newInstancePhone}
                  onChange={(e) => setNewInstancePhone(e.target.value)}
                  placeholder="5567999999999"
                  className="w-full px-4 py-2.5 bg-background border border-border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary/50 transition-all"
                  disabled={isCreatingInstance || !!pendingQRCode}
                />
              </div>
            </div>

            {/* Coluna 2: QR Code / Botão - tamanho maior */}
            <div className="w-[140px] h-[140px] flex-shrink-0 flex items-center justify-center">
              {!pendingQRCode ? (
                /* Botão Gerar QR */
                <button
                  onClick={createInstance}
                  disabled={isCreatingInstance || !newInstanceName.trim()}
                  className="w-full h-full flex flex-col items-center justify-center gap-2 bg-primary text-primary-foreground rounded-xl font-medium hover:bg-primary/90 transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:shadow-none"
                >
                  {isCreatingInstance ? (
                    <div className="w-8 h-8 border-3 border-white/30 border-t-white rounded-full animate-spin" />
                  ) : (
                    <FiSmartphone className="w-8 h-8" />
                  )}
                  <span className="text-sm font-semibold">{isCreatingInstance ? 'Gerando...' : 'Gerar QR'}</span>
                </button>
              ) : connectionStatus === 'connected' ? (
                /* Sucesso - Conectado */
                <div className="w-full h-full flex flex-col items-center justify-center gap-2 bg-green-500/10 border-2 border-green-500 rounded-xl">
                  <FiCheck className="w-10 h-10 text-green-500" />
                  <span className="text-sm font-semibold text-green-500">Conectado!</span>
                </div>
              ) : connectionStatus === 'expired' ? (
                /* Expirado - Botão tentar novamente */
                <button
                  onClick={deleteInstanceAndRetry}
                  className="w-full h-full flex flex-col items-center justify-center gap-2 bg-red-500/10 border-2 border-red-500 rounded-xl hover:bg-red-500/20 transition-colors"
                >
                  <FiX className="w-8 h-8 text-red-500" />
                  <span className="text-sm font-semibold text-red-500">Tentar novamente</span>
                </button>
              ) : (
                /* QR Code - Clicável para expandir */
                <button
                  onClick={() => setShowQRModal(true)}
                  className="w-full h-full bg-white rounded-xl p-2 flex flex-col items-center justify-center shadow-lg hover:shadow-xl transition-shadow cursor-pointer group"
                  title="Clique para expandir"
                >
                  <img src={pendingQRCode} alt="QR Code" className="w-full h-full object-contain" />
                  <span className="text-[9px] text-gray-400 group-hover:text-gray-600 mt-0.5 transition-colors">Clique para ampliar</span>
                </button>
              )}
            </div>

            {/* Coluna 3: Info - Countdown e Pairing Code */}
            <div className="flex-1 flex flex-col justify-center gap-3 min-w-0">
              {pendingQRCode && connectionStatus === 'waiting' && (
                <>
                  {/* Countdown e Status */}
                  <div className="flex items-center gap-4">
                    <div className={`w-14 h-14 rounded-full flex items-center justify-center text-xl font-bold shadow-md ${
                      countdown <= 10 ? 'bg-red-500 text-white' : 'bg-primary/20 text-primary'
                    }`}>
                      {countdown}
                    </div>
                    <div>
                      <p className="font-semibold text-base text-foreground">Aguardando...</p>
                      <p className="text-sm text-muted-foreground">Escaneie o QR Code com seu WhatsApp</p>
                    </div>
                  </div>
                  {/* Pairing Code */}
                  {pendingPairingCode && (
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-sm text-muted-foreground">Código:</span>
                      <span className="font-mono font-bold text-base text-foreground bg-secondary/50 px-3 py-1.5 rounded-lg tracking-wider">
                        {pendingPairingCode}
                      </span>
                    </div>
                  )}
                </>
              )}
              {connectionStatus === 'connected' && (
                <div className="flex items-center gap-3">
                  <FiCheck className="w-6 h-6 text-green-500" />
                  <div>
                    <p className="font-semibold text-base text-green-500">Conectado!</p>
                    <p className="text-sm text-muted-foreground">Dispositivo pronto para uso</p>
                  </div>
                </div>
              )}
              {connectionStatus === 'expired' && (
                <div className="flex items-center gap-3">
                  <FiAlertCircle className="w-6 h-6 text-red-500" />
                  <div>
                    <p className="font-semibold text-base text-red-500">QR Code expirado</p>
                    <p className="text-sm text-muted-foreground">Clique para tentar novamente</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Existing Instance Form - Compact Inline (after choosing 'existing') */}
      {showNewInstanceForm && !pendingQRCode && deviceFormMode === 'existing' && (
        <div className="px-4 py-3">
          <div className="flex items-center gap-4">
            <button
              onClick={() => {
                setDeviceFormMode('choice')
                setExistingInstanceName('')
                setExistingInstanceApiKey('')
              }}
              className="p-1 text-muted-foreground hover:text-foreground transition-colors"
              title="Voltar"
            >
              <FiX className="w-4 h-4" />
            </button>
            <input
              type="text"
              value={existingInstanceName}
              onChange={(e) => setExistingInstanceName(e.target.value)}
              placeholder="Nome da instância"
              className="flex-1 px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-primary/50"
              disabled={isSavingExistingInstance}
            />
            <input
              type="password"
              value={existingInstanceApiKey}
              onChange={(e) => setExistingInstanceApiKey(e.target.value)}
              placeholder="API Key"
              className="flex-1 px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-primary/50"
              disabled={isSavingExistingInstance}
            />
            <button
              onClick={handleSaveExistingInstanceInline}
              disabled={isSavingExistingInstance || !existingInstanceName.trim() || !existingInstanceApiKey.trim()}
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors disabled:opacity-50 whitespace-nowrap"
            >
              {isSavingExistingInstance ? (
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                <FiCheck className="w-4 h-4" />
              )}
              {isSavingExistingInstance ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      )}

      {/* Devices List */}
      {devices.length > 0 && (
        <div className="px-3 py-2">
          <div className="grid grid-cols-2 gap-2">
          {devices.map((device) => (
            <div
              key={device.id}
              className="flex items-center gap-2.5 p-2 bg-card border border-border rounded-lg hover:border-primary/30 hover:shadow-sm transition-all"
            >
              {device.connectionInfo ? (
                // Dispositivo CONECTADO
                <>
                  {/* Avatar compacto */}
                  <div className="relative flex-shrink-0">
                    {device.connectionInfo.profilePicUrl ? (
                      <img
                        src={device.connectionInfo.profilePicUrl}
                        alt={device.connectionInfo.profileName}
                        className="w-9 h-9 rounded-full object-cover"
                        onError={(e) => {
                          e.currentTarget.style.display = 'none'
                          const fallback = e.currentTarget.nextElementSibling as HTMLElement
                          if (fallback) fallback.style.display = 'flex'
                        }}
                      />
                    ) : null}
                    <div
                      className="w-9 h-9 rounded-full bg-primary/20 flex items-center justify-center text-primary text-sm font-semibold"
                      style={{ display: device.connectionInfo.profilePicUrl ? 'none' : 'flex' }}
                    >
                      {getInitials(device.connectionInfo.profileName || device.name)}
                    </div>
                    <div className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-green-400 rounded-full border-2 border-card" />
                  </div>

                  {/* Info compacta */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-1">
                      {/* Badge do tipo de API */}
                      {device.apiType === 'meta' ? (
                        <span className="text-[9px] bg-blue-500/20 text-blue-600 dark:text-blue-400 px-1 py-0.5 rounded font-medium">
                          Meta
                        </span>
                      ) : (
                        <span className="text-[9px] bg-green-500/20 text-green-600 dark:text-green-400 px-1 py-0.5 rounded font-medium">
                          Evolution
                        </span>
                      )}
                      <span className="text-xs font-semibold truncate">{device.name}</span>
                    </div>
                    <div className="flex items-center gap-1.5 mt-0.5">
                      <span className="text-[10px] text-green-500 truncate max-w-[80px]">{device.connectionInfo.profileName}</span>
                    </div>
                    <div className="flex items-center gap-1 text-[10px] text-muted-foreground mt-0.5">
                      <span className="truncate">{device.apiType === 'meta' && device.displayPhone ? device.displayPhone : formatPhone(device.connectionInfo.ownerJid)}</span>
                      <span>•</span>
                      <span>{new Date(device.createdAt).toLocaleString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}</span>
                    </div>
                  </div>

                  {/* Actions compactas */}
                  <div className="flex items-center gap-1 flex-shrink-0">
                    {/* Botão Inbox - Toggle */}
                    <button
                      onClick={() => {
                        if (activeInboxDeviceId === device.id) {
                          onCloseInbox?.()
                        } else {
                          onOpenInbox?.(device.id, device.name, device.aiAgentEnabled || false, device.apiType as 'evolution' | 'meta')
                        }
                      }}
                      className={`relative p-1.5 rounded-full transition-all ${
                        activeInboxDeviceId === device.id
                          ? 'bg-green-500 text-white ring-2 ring-green-300'
                          : 'bg-blue-100 dark:bg-blue-500/20 text-blue-600 dark:text-blue-400 hover:bg-blue-200 dark:hover:bg-blue-500/30'
                      }`}
                      title={activeInboxDeviceId === device.id ? "Voltar ao Chat IA" : "Abrir conversas"}
                    >
                      {device.apiType === 'meta' ? (
                        <MetaIcon className="w-4 h-4" />
                      ) : (
                        <WhatsAppIcon className="w-4 h-4" />
                      )}
                      {(Number(device.unreadCount) || 0) > 0 && (() => {
                        // Calcular urgência baseada na mensagem mais antiga (ativas ou arquivadas)
                        const activeHours = device.unreadActive?.hoursOld ?? null
                        const archivedHours = device.unreadArchived?.hoursOld ?? null
                        const oldestHours = activeHours !== null && archivedHours !== null
                          ? Math.max(activeHours, archivedHours)
                          : activeHours ?? archivedHours
                        const urgency = getUrgencyColor(oldestHours)
                        const styles = urgencyStyles[urgency]

                        return (
                          <span
                            className={`absolute -top-1 -right-1 ${styles.badge} text-[9px] rounded-full min-w-[14px] h-[14px] flex items-center justify-center font-bold px-0.5 shadow-sm`}
                            title={oldestHours !== null ? `Mensagem mais antiga: ${oldestHours}h` : 'Mensagens não lidas'}
                          >
                            {(Number(device.unreadCount) || 0) > 999 ? '999+' : device.unreadCount}
                          </span>
                        )
                      })()}
                    </button>

                    {/* Botão Analytics */}
                    <button
                      onClick={() => onOpenAnalytics?.(device.id, device.name)}
                      className={`p-1.5 rounded-full transition-all ${
                        activeAnalyticsDeviceId === device.id
                          ? 'bg-purple-500 text-white ring-2 ring-purple-300'
                          : 'bg-purple-100 dark:bg-purple-500/20 text-purple-600 dark:text-purple-400 hover:bg-purple-200 dark:hover:bg-purple-500/30'
                      }`}
                      title="Ver analytics"
                    >
                      <FiBarChart2 className="w-4 h-4" />
                    </button>

                    <button
                      onClick={() => openAgentSelectionModal(device.id, device.name, device.aiAgentEnabled || false)}
                      className={`p-1.5 rounded-full transition-all relative group ${
                        device.aiAgentEnabled
                          ? 'bg-blue-100 dark:bg-blue-500/20 hover:bg-blue-200 dark:hover:bg-blue-500/30'
                          : 'bg-gray-100 dark:bg-gray-500/20 hover:bg-gray-200 dark:hover:bg-gray-500/30'
                      }`}
                      title={device.aiAgentEnabled && device.agentName ? `Agente: ${device.agentEmoji || ''} ${device.agentName}` : device.aiAgentEnabled ? 'Desativar agente de IA' : 'Ativar agente de IA'}
                    >
                      <IaIcon className="w-4 h-4" active={device.aiAgentEnabled || false} />

                      {/* Tooltip com nome do agente */}
                      {device.aiAgentEnabled && device.agentName && (
                        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                          <div className="flex items-center gap-1.5">
                            {device.agentEmoji && <span className="text-sm">{device.agentEmoji}</span>}
                            <span>{device.agentName}</span>
                          </div>
                          <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-0.5 border-4 border-transparent border-t-gray-900"></div>
                        </div>
                      )}
                    </button>

                    <button
                      onClick={() => confirmDeleteDevice(device)}
                      className="p-1.5 rounded-full bg-yellow-100 dark:bg-yellow-500/20 text-yellow-600 dark:text-yellow-400 hover:bg-yellow-200 dark:hover:bg-yellow-500/30 transition-all"
                      title="Remover dispositivo"
                    >
                      <FiTrash2 className="w-4 h-4" />
                    </button>
                  </div>
                </>
              ) : (
                // Dispositivo DESCONECTADO
                <>
                  {/* Avatar compacto com indicador offline */}
                  <div className="relative flex-shrink-0">
                    <div className="w-9 h-9 rounded-full bg-muted/30 flex items-center justify-center text-muted-foreground text-sm font-semibold">
                      {getInitials(device.name)}
                    </div>
                    <div className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-red-400 rounded-full border-2 border-card" />
                  </div>

                  {/* Info compacta */}
                  <div className="flex-1 min-w-0 opacity-60">
                    <div className="flex items-center gap-1">
                      {/* Badge do tipo de API */}
                      {device.apiType === 'meta' ? (
                        <span className="text-[9px] bg-blue-500/20 text-blue-600 dark:text-blue-400 px-1 py-0.5 rounded font-medium">
                          Meta
                        </span>
                      ) : (
                        <span className="text-[9px] bg-green-500/20 text-green-600 dark:text-green-400 px-1 py-0.5 rounded font-medium">
                          Evolution
                        </span>
                      )}
                      <span className="text-xs font-semibold truncate text-muted-foreground">{device.name}</span>
                    </div>
                    <div className="flex items-center gap-1 mt-0.5">
                      <span className="text-[9px] text-red-400 bg-red-500/10 px-1 py-0.5 rounded">Desconectado</span>
                    </div>
                    <div className="flex items-center gap-1 text-[10px] text-muted-foreground mt-0.5">
                      <span>{new Date(device.createdAt).toLocaleString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}</span>
                    </div>
                  </div>

                  {/* Actions - só delete para dispositivo desconectado */}
                  <div className="flex items-center gap-1 flex-shrink-0">
                    <button
                      onClick={() => confirmDeleteDevice(device)}
                      className="p-1.5 hover:bg-red-500/10 rounded-md text-red-500/70 hover:text-red-500 transition-colors"
                      title="Remover dispositivo"
                    >
                      <FiTrash2 className="w-4 h-4" />
                    </button>
                  </div>
                </>
              )}
            </div>
          ))}
          </div>
        </div>
      )}

      {/* Empty State */}
      {devices.length === 0 && !showNewInstanceForm && !pendingQRCode && !isLoading && (
        <div className="text-center py-12">
          <FiSmartphone className="w-12 h-12 text-muted-foreground/30 mx-auto mb-4" />
          <p className="text-muted-foreground text-sm">Nenhum dispositivo conectado</p>
          <p className="text-muted-foreground/60 text-xs mt-1">Clique em "Nova Instância" para conectar</p>
        </div>
      )}

      {/* Loading State */}
      {isLoading && devices.length === 0 && (
        <div className="text-center py-12">
          <div className="w-8 h-8 border-2 border-primary/30 border-t-primary rounded-full animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground text-sm">Carregando dispositivos...</p>
        </div>
      )}

      {/* Modal QR Code Expandido */}
      {showQRModal && pendingQRCode && (
        <div
          className="fixed inset-0 glass-overlay flex items-center justify-center z-50 p-4"
          onClick={() => setShowQRModal(false)}
        >
          <div
            className="glass-panel rounded-2xl max-w-md w-full p-6 relative animate-in fade-in zoom-in-95 duration-200"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="font-semibold text-lg">Escaneie o QR Code</h3>
                <p className="text-sm text-muted-foreground">Abra o WhatsApp e escaneie</p>
              </div>
              <button
                onClick={() => setShowQRModal(false)}
                className="p-2 hover:bg-muted rounded-lg transition-colors"
              >
                <FiX className="w-5 h-5" />
              </button>
            </div>

            {/* QR Code Grande */}
            <div className="bg-white rounded-xl p-4 mb-4">
              <img
                src={pendingQRCode}
                alt="QR Code"
                className="w-full aspect-square object-contain"
              />
            </div>

            {/* Info */}
            <div className="flex items-center justify-between">
              {/* Countdown */}
              <div className="flex items-center gap-3">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center text-lg font-bold ${
                  countdown <= 10 ? 'bg-red-500 text-white' : 'bg-primary/20 text-primary'
                }`}>
                  {countdown}
                </div>
                <div className="text-sm">
                  <p className="font-medium">Aguardando conexão...</p>
                  <p className="text-muted-foreground text-xs">Tempo restante</p>
                </div>
              </div>

              {/* Pairing Code */}
              {pendingPairingCode && (
                <div className="text-right">
                  <p className="text-xs text-muted-foreground mb-1">Código de pareamento</p>
                  <span className="font-mono font-bold text-lg bg-secondary/50 px-3 py-1.5 rounded-lg tracking-widest">
                    {pendingPairingCode}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Mini-Modal: Seleção de Agente de IA */}
      {agentSelectionModal.isOpen && (
        <div
          className="fixed inset-0 glass-overlay flex items-center justify-center z-50 p-4"
          onClick={cancelAgentSelection}
        >
          <div
            className="glass-panel rounded-xl max-w-sm w-full p-4 animate-in fade-in zoom-in-95 duration-200"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                <div className="p-2 bg-blue-500/10 rounded-lg">
                  <IaIcon className="w-5 h-5" active={true} />
                </div>
                <div>
                  <h3 className="font-semibold text-sm">Ativar Agente de IA</h3>
                  <p className="text-xs text-muted-foreground">{agentSelectionModal.deviceName}</p>
                </div>
              </div>
              <button
                onClick={cancelAgentSelection}
                className="p-1.5 hover:bg-muted rounded-lg transition-colors"
              >
                <FiX className="w-4 h-4" />
              </button>
            </div>

            {/* Agent List */}
            <div className="mb-3">
              <label className="text-xs font-medium text-muted-foreground mb-2 block">
                Selecione o agente que responderá automaticamente:
              </label>
              {isLoadingAgents ? (
                <div className="flex items-center justify-center py-6">
                  <div className="w-6 h-6 border-2 border-primary/30 border-t-primary rounded-full animate-spin" />
                </div>
              ) : availableAgents.length === 0 ? (
                <div className="text-center py-6">
                  <p className="text-xs text-muted-foreground">Nenhum agente disponível</p>
                  <p className="text-xs text-muted-foreground/60 mt-1">Crie um agente primeiro</p>
                </div>
              ) : (
                <div className="space-y-1.5 max-h-[240px] overflow-y-auto">
                  {availableAgents.map((agent) => (
                    <button
                      key={agent.id}
                      onClick={() => setSelectedAgentId(agent.id)}
                      className={`w-full flex items-center gap-2.5 p-2.5 rounded-lg border transition-all ${
                        selectedAgentId === agent.id
                          ? 'bg-primary/10 border-primary shadow-sm'
                          : 'bg-background border-border hover:border-primary/30 hover:bg-accent/30'
                      }`}
                    >
                      <div className={`text-2xl flex-shrink-0 ${
                        selectedAgentId === agent.id ? 'scale-110' : ''
                      } transition-transform`}>
                        {agent.emoji}
                      </div>
                      <div className="flex-1 text-left min-w-0">
                        <p className={`text-sm font-medium truncate ${
                          selectedAgentId === agent.id ? 'text-primary' : 'text-foreground'
                        }`}>
                          {agent.name}
                        </p>
                      </div>
                      {selectedAgentId === agent.id && (
                        <FiCheck className="w-4 h-4 text-primary flex-shrink-0" />
                      )}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Actions */}
            <div className="flex gap-2">
              <button
                onClick={cancelAgentSelection}
                className="flex-1 px-3 py-2 bg-secondary text-secondary-foreground rounded-lg text-sm font-medium hover:bg-secondary/80 transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={confirmAgentSelection}
                disabled={!selectedAgentId}
                className="flex-1 px-3 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Ativar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação de Exclusão */}
      <ConfirmDialog
        isOpen={deleteConfirmation.isOpen}
        title="Excluir Instância"
        message={`Tem certeza que deseja excluir a instância "${deleteConfirmation.device?.name}"?`}
        details={[
          'A instância será removida da Evolution API',
          'Todas as conversas associadas serão perdidas',
          'Esta ação não pode ser desfeita'
        ]}
        onConfirm={executeDeleteDevice}
        onCancel={cancelDeleteDevice}
        confirmText="Sim, excluir"
        cancelText="Cancelar"
        type="danger"
      />

    </div>
  )
})
